<!-- Temporary Vue bridge for the wired timesheet panel. -->
<!-- Prefer Zone-based dialogs for future work instead of extending this wrapper further. -->

<template lang="pug">
div
  TimeEntriesFormDialog(
    v-if="timeEntryReady"
    :show="show"
    :type="'edit'"
    :time-entry="timeEntry"
    :on-save="onSave"
    @close="close"
  )
</template>

<script>
import { mapGetters } from 'vuex';
import { setMomentStartStop } from '~/utils/time_entry_utils';

export default {
  name: 'TimeEntriesFormDialogWired',
  data() {
    return {
      panel: null,
      show: false,
      timeEntry: null,
    };
  },
  computed: {
    ...mapGetters(['currentZone']),
    timeEntryReady() {
      return !!(this.timeEntry?.start_time && this.timeEntry?.stop_time);
    },
  },
  created() {
    this.handleOpenRequest = (event) => {
      const timeEntry = this.normalizeTimeEntry(event.detail.timeEntry);

      if (!timeEntry) {
        return;
      }

      this.timeEntry = timeEntry;
      this.$store.dispatch('setSelectedTimeEntry', {timeEntry});
      this.show = true;
    };
  },
  mounted() {
    this.eventTarget = this.$el.closest('turbo-frame');
    this.eventTarget.addEventListener('open-time-entry-edit', this.handleOpenRequest);
    this.panel = this.eventTarget.closest('[x-data]')._x_dataStack[0];
  },
  beforeUnmount() {
    this.eventTarget.removeEventListener('open-time-entry-edit', this.handleOpenRequest);
  },
  methods: {
    normalizeTimeEntry(timeEntry) {
      if (!timeEntry) {
        return null;
      }

      return setMomentStartStop(timeEntry, this.currentZone.name);
    },
    onSave() {
      return this.panel.loadData();
    },
    close() {
      this.show = false;
      this.$nextTick(() => {
        this.timeEntry = null;
      });
    },
  },
};
</script>
